import axios from "axios";

const extractTokenFromCookie = (): string | null => {
  try {
    const cookies = document.cookie.split(";");
    const uTokenCookie = cookies.find((cookie) =>
      cookie.trim().startsWith("u_token="),
    );

    if (!uTokenCookie) {
      const backofficeTokenCookie = cookies.find((cookie) =>
        cookie.trim().startsWith("backoffice_token="),
      );

      if (!backofficeTokenCookie) {
        return null;
      }

      return backofficeTokenCookie.split("=")[1];
    }

    return uTokenCookie.split("=")[1];
  } catch (error) {
    console.error("Erro ao extrair token do cookie:", error);
    return null;
  }
};

export const apiGateway = axios.create({
  baseURL: import.meta.env.VITE_API_GATEWAY,
  headers: {
    "Content-Type": "application/json",
  },
});

apiGateway.interceptors.request.use(
  (config) => {
    const token = extractTokenFromCookie();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);
